var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27 20.5C27 24.0899 24.0899 27 20.5 27C16.9101 27 14 24.0899 14 20.5C14 16.9101 16.9101 14 20.5 14C24.0899 14 27 16.9101 27 20.5ZM26.0413 28.2174C24.4816 29.3393 22.568 30 20.5 30C15.2533 30 11 25.7467 11 20.5C11 15.2533 15.2533 11 20.5 11C25.7467 11 30 15.2533 30 20.5C30 22.5662 29.3404 24.4783 28.2202 26.0373L32.5435 30.3606L30.364 32.5401L26.0413 28.2174Z","fill":"black","key":1})]);
}

Search.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Search;

Search.default = Search;
